import {
  GridLegacy as Grid,
  Paper,
  Typography,
  Box,
  Menu,
  MenuItem,
  Fade,
  Snackbar,
  Alert,
  AlertColor,
  Stack,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { SilobagListFilters } from '../../features/silobags/silobags-list/silobag-filters';
import {
  Title,
  CustomPaper,
  mainContainerStyle,
  typographyStyle,
  configButtonStylesOutlined,
  configButtonStylesContained,
} from '../../styles/generic-styles';
import { useLocation, useNavigate } from 'react-router';
import { PATH } from '@old/data/core/paths';
import { formatTons, formatDate } from '@old/utils/helper';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { GenerateSilobagExcelData, GenerateExtractionsExcelData } from '@old/utils/export-files';
import { useService } from '@old/hooks/use-service';
import { useToggle } from '@old/hooks/core';
import { ExtractionAction } from '@old/features/silobags/silobag-detail/exctraction-modal';
import { useEffectOnUpdate } from '@old/hooks/core';
import downloadPdfIcon from '@old/assets/svg/downloadIcon.svg';
import i18n from '../../libs/language';
import {
  downloadSilobagExcel,
  uploadSilobagExcel,
  uploadCloseSilobagExcel,
  downloadCloseExcel,
} from '@old/utils/import-files';
import { listSilobagService } from '@old/services/domain/base/silobag/base/silobag-list';
import { listCountrysideService } from '@old/services/domain/base/countryside/countryside-list';
import { ToastAction } from '@old/ui/toast/toast-action';
import { utils, writeFile } from 'xlsx';
import { ModalInfoRegisterSilobags } from '@old/features/silobags/modal-info-silobag/modal-info';
import { SilobagShareModal } from '@old/features/silobags/silobag-share/silobag-share';
import { sharePermissionListService } from '@old/services/domain/base/silobag/share/share-list';
import ShareICON from '@old/assets/svg/share.svg';
import shareDisabledIcon from '@old/assets/svg/share-disabled.svg';
import { useGlobalStore } from '@old/global-store/use-store';
import { SILOBAG_STATUSES_ID } from '@old/data/to-refactor/constants';
import { SilobagModalMassiveClose } from '@old/features/silobags/silobag-close/silobag-close';
import { DownloadLabTemplateModal } from '@old/features/silobags/lab-template-modal/lab-template-modal';
import { importLabProtocolService } from '@old/services/domain/laboratory/lab-protocol-import';
import { silobagCMAService } from '@old/services/domain/base/silobag/file/cmc';
import { extractionListService } from '@old/services/domain/base/silobag/extraction/extraction-list';
import { silobagMassiveUploadService } from '@old/services/domain/base/silobag/base/massive-upload';
import {
  invertMap,
  culturaMap,
  produtoMap,
  humidityMap,
  weightMap,
  sidechargeMap,
} from '../../utils/import-files';
import { listWebSilobagsService } from '@old/services/domain/base/silobag/base/silobag-web';
// import { silobagInsuranceValidationService } from '@old/services/domain/base/silobag/base/silobag-insurance-validation';
import { SilobagInsuranceValidation } from '@old/features/silobags/silobag-insurance-validation/silobag-insurance-validation';
import { silobagMassiveCloseService } from '@old/services/domain/base/silobag/base/massive-close';
import { WarrantApplicationModal } from '@old/features/warrant-modals/warrant-application-modal';
import { getWarrantReferenceService } from '@old/services/domain/base/administrator/warrants/get-warrant-reference';
import { WarrantIntroductionModal } from '@old/features/warrant-modals/warrant-introduction-modal';
import { ArchivableSbModal } from '@old/features/archivable-sb/archivable-modal';
import { SilobagMassiveRegisterSpreadsheetModal } from '@old/features/spreadsheet/controller/silobag-massive-register';
import { BetaBadge } from '@old/ui/beta-badge';
import { reportSatViewService } from '@old/services/domain/silosat/report-sat-v2';
import { ReportSatelitalModal } from '@old/features/silobags/report-satelital-modal/report-satelital-moda';
import { useShallow } from 'zustand/react/shallow';
import { SpeciesID } from '@old/typed/domain/base/silobag/silobag-species.types';

type ResponseItemClose = {
  id: string;
  status: string;
  message?: string;
};

interface ErrorItem {
  Errores: string;
  id?: string;
}

type SummarySilobagList = Awaited<ReturnType<typeof listSilobagService>>['summary']['data'];
type SharePermissionList = Awaited<ReturnType<typeof sharePermissionListService>>['summary'];

type SiloHeaderData = {
  totalRemainingStock: number;
  silobagQty: number;
  remainingStock: number;
  web_silobags_stock: number;
  filteredInputWeight: number;
  filteredExtractedWeight: number;
  filteredRemainingStock: number;
};

export function SilobagListPage() {
  const {
    country_id,
    filters,
    filteredUrl,
    organizationId,
    selectedOrganizationName,
    setFilters,
    permissions: organizationPermissions,
    userOrganizationId,
  } = useGlobalStore(useShallow((s) => s));
  const orgWritePermission = organizationPermissions?.organization.write;
  const orgFullPermission = organizationPermissions?.organization.full;
  const location = useLocation();
  const { state } = location;
  const newSiloSuccess = useRef(state?.newOrEditSilobagSuccessfull);
  const [siloHeaderData, setSiloHeaderData] = useState<SiloHeaderData>({
    totalRemainingStock: 0,
    silobagQty: 0,
    remainingStock: 0,
    web_silobags_stock: 0,
    filteredInputWeight: 0,
    filteredExtractedWeight: 0,
    filteredRemainingStock: 0,
  });
  const [siloListAll, setSiloListAll] = useState<SummarySilobagList | undefined>([]);
  const [siloListFilter, setSiloListFilter] = useState<SummarySilobagList | undefined>([]);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useToggle(false);
  const [typeSnackbar, setTypeSnackbar] = useState<'success' | 'error'>('success');
  const [remainingStock, setRemainingStock] = useState<string | null | number>(0);
  const [modalExtraction, setModalExtraction] = useToggle(false);
  const [paramsExportFilter, setParamsExportFilter] = useState({});
  const [extractionSuccess, setExtractionSuccess] = useState(false);
  const [percetageFiltered, setPercentageFiltered] = useState(100);
  const [targetSilobagDataSelection, setTargetSilobagDataSelection] = useState<SummarySilobagList>([]);

  const [modalShare, setModalShare] = useToggle(false);
  const [modalClose, setModalClose] = useToggle(false);
  const [modalInsurance, setModalInsurance] = useToggle(false);
  const [permissions, setPermissions] = useState<SharePermissionList[]>([]);
  const [hasSilobagValidated, setHasSilobagValidated] = useState(false);
  const [openWarrantModal, setOpenWarrantModal] = useToggle(false);
  const [openArchiveModal, setOpenArchiveModal] = useToggle(false);
  const [openReportModal, setOpenReportModal] = useToggle(false);
  const [toastArchivable, setToastArchivable] = useState({
    message: '',
    severity: 'success' as AlertColor,
    open: false,
  });
  // CHEQUEA SI EL LISTADO ES DE SILOBOLSAS CERRADAS
  const [isCloseList, setIsCloseList] = useToggle(!filters.active);

  const [silobagShared, setSilobagShared] = useState<{
    message: string;
    state: boolean;
    type: 'success' | 'error';
  }>({ message: '', state: false, type: 'success' });
  const [isNonValidatedSBList, setIsNonValidatedSBList] = useToggle(false);
  const [toastState, setToastState] = useToggle(false);
  useEffectOnUpdate(() => {
    setToastState(silobagShared.state);
  }, [silobagShared]);

  const {
    trigger: getExtracions,
    summary: dataExtractions,
    isLoading: isLoadingExtractions,
  } = useService(extractionListService);
  const navigate = useNavigate();

  const { trigger: triggerGetWebSilobags, summary: webSilobagsCount } = useService(listWebSilobagsService, {
    fetchOnMount: [organizationId],
  });

  useEffectOnUpdate(() => {
    triggerGetWebSilobags(organizationId);
  }, [organizationId]);

  // SE HACE UN GET DE countrysides Y NO EL ESTADO GLOBAL PORQUE NO ESTÁ ACTUALIZANDO CUANDO SE ELIMINA/AGREGA UNO DESDE ADMINISTRADOR
  const queryCountrysideList = { organization_id: organizationId };
  const { summary: countrysides, isLoading: isCountrysideLoading } = useService(listCountrysideService, {
    fetchOnMount: [{ query: queryCountrysideList }],
  });

  useEffectOnUpdate(() => {
    if (!isLoadingExtractions && dataExtractions) {
      GenerateExtractionsExcelData(dataExtractions);
    }
  }, [!isLoadingExtractions]);

  const handlerUpdateHeaderData = (newState: SiloHeaderData) => {
    setSiloHeaderData(newState);
    if (newState?.totalRemainingStock === 0) return setPercentageFiltered(0);
    const percentage = (newState?.remainingStock / newState?.totalRemainingStock) * 100;
    const percentageInt = parseInt(percentage.toString(), 10);
    setPercentageFiltered(percentageInt);
  };

  const { summary: warrantsReferences } = useService(getWarrantReferenceService, {
    fetchOnMount: [{ query: { externalReference: organizationId } }],
  });

  const {
    trigger: getSiloPermission,
    summary: dataSiloPermission,
    isLoading: isLoadingSiloPermission,
  } = useService(sharePermissionListService);

  const handleGetSiloListFilter = (newState?: SummarySilobagList) => {
    setSiloListFilter(newState);
  };

  const handleGetSiloListAll = (newState?: SummarySilobagList) => {
    setSiloListAll(newState);
  };

  const handleGetParamsFilter = (newState: string | string[] | Record<string, string>) => {
    setParamsExportFilter(newState);
  };
  const paramsExportFilterString = Object.values(paramsExportFilter).join(' ');

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElMassive, setAnchorElMassive] = useState<null | HTMLElement>(null);
  const [openMassive, setOpenMassive] = useState({ upload: false, close: false });
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [isMassiveClose, setIsMassiveClose] = useState(false);
  const [openMassiveSilobagRegisterModal, setOpenMassiveSilobagRegisterModal] = useToggle(false);
  const [toast, setToast] = useState({
    message: '',
    severity: undefined as AlertColor | undefined,
    open: false,
  });
  const open = Boolean(anchorEl);
  const [showMigrationBanner, setShowMigrationBanner] = useState(true);

  const handleCloseMigrationBanner = () => {
    setShowMigrationBanner(false);
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickMassive = (menuId: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElMassive(event.currentTarget);
    // Explicitly setting states based on the action to avoid unintended side effects
    if (menuId === 'upload') {
      setOpenMassive((prev) => ({ ...prev, upload: !prev.upload, close: false }));
    } else if (menuId === 'close') {
      setOpenMassive((prev) => ({ ...prev, close: !prev.close, upload: false }));
    }
  };

  const handleDownloadClick = () => {
    setAnchorElMassive(null);
    setOpenMassive((prev) => ({ ...prev, upload: false }));
    downloadSilobagExcel();
  };

  const {
    summary: dataCMA,
    isLoading: isLoadingCMA,
    isSuccess: isSuccessCmA,
  } = useService(silobagCMAService);
  function downloadFile(fileUrl: string, fileName: string) {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (isSuccessCmA && dataCMA) downloadFile(dataCMA.file_path, `file${dataCMA}.pdf`);
  }, [dataCMA, isSuccessCmA]);

  const handleUploadCloseClick = () => {
    setAnchorElMassive(null);
    setOpenMassive((prev) => ({ ...prev, upload: false }));
    const fileUpload = document.getElementById('fileUploadClose');
    fileUpload?.click();
  };

  const handleDownloadCloseClick = () => {
    setAnchorElMassive(null);
    setOpenMassive((prev) => ({ ...prev, upload: false }));
    downloadCloseExcel();
  };

  const {
    trigger: createMassiveSilobag,
    summary: massiveSilobagSummary,
    isSuccess,
  } = useService(silobagMassiveUploadService, {
    onSuccess: () => {
      setFilters({ ...filters, silobag_data_status_id: 1 });
      setToast({
        message: '',
        severity: 'success',
        open: false,
      });
    },
  });

  const {
    trigger: createMassiveCloseSilobag,
    summary: summaryClose,
    isSuccess: isSuccessClose,
    isError: errorClose,
  } = useService(silobagMassiveCloseService, {
    onSuccess: () => {
      setToast({
        message: '',
        severity: 'success',
        open: false,
      });
    },
  });

  // TODO: Tipar ErrorData
  // TODO: Tipar summaryClose
  useEffect(() => {
    if (summaryClose?.length) {
      const silobagValidated = summaryClose.some((item) => item.silobag_data?.silobag_data_status_id === 1);
      setHasSilobagValidated(silobagValidated);
    }
  }, [summaryClose]);

  useEffect(() => {
    if (errorClose) {
      setToast({
        message: 'No posee permisos suficientes.',
        severity: 'error',
        open: true,
      });
    }
  }, [errorClose]);
  const handleSummaryClose = (summary: ResponseItemClose[] | undefined) => {
    if (!summary) return;

    const { successCount, errorCount, errors } = summarizeResults(summary);

    setToastMessage(successCount, errorCount);

    if (errors.length > 0) {
      generateErrorReport(errors);
    }
  };
  const summarizeResults = (summary: ResponseItemClose[]) => {
    let successCount = 0;
    let errorCount = 0;
    const errors: ErrorItem[] = [];

    summary.forEach(({ id, status, message }) => {
      if (status === 'closed') {
        successCount++;
      } else if (status === 'error') {
        errorCount++;
        errors.push({ id, Errores: message || 'Error desconocido' });
      }
    });

    return { successCount, errorCount, errors };
  };

  const setToastMessage = (successCount: number, errorCount: number) => {
    if (errorCount === 0) {
      return setToast({
        message: i18n.t('app.silobag_action.close_success'),
        severity: 'success',
        open: true,
      });
    }

    if (successCount > 0) {
      return setToast({
        message: i18n.t('app.silobag_action.close_warning'),
        severity: 'warning',
        open: true,
      });
    }

    return setToast({
      message: i18n.t('app.silobag_action.close_error'),
      severity: 'error',
      open: true,
    });
  };

  const generateErrorReport = (errors: ErrorItem[]) => {
    const worksheet = utils.json_to_sheet(errors);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Errores');
    writeFile(workbook, 'errores.xlsx');
  };

  const CulturaMap = invertMap(culturaMap);
  const ProdutoMap = invertMap(produtoMap);
  const HumidityMap = invertMap(humidityMap);
  const WeightMap = invertMap(weightMap);
  const SidechargeMap = invertMap(sidechargeMap);

  const translateData = (data: NonNullable<SilobagMassiveUploadType['error']>['data'], language: string) => {
    if (language !== 'pt') {
      return data;
    }

    return {
      ...data,
      silobag_species_type_name: CulturaMap[data.silobag_species_type_name] || data.silobag_species_type_name,
      silobag_product_type_name: ProdutoMap[data.silobag_product_type_name] || data.silobag_product_type_name,
      humidity_source_description:
        HumidityMap[data.humidity_source_description] || data.humidity_source_description,
      weight_source_description: WeightMap[data.weight_source_description] || data.weight_source_description,
      side_charge_description: SidechargeMap[data.side_charge_description] || data.side_charge_description,
    };
  };

  type MassiveUploadType = Awaited<ReturnType<typeof silobagMassiveUploadService>>['summary'];
  type SilobagMassiveUploadType = MassiveUploadType[0];

  const handleSummary = (summary: MassiveUploadType | undefined) => {
    const language = i18n.locale;
    if (summary) {
      let successCount = 0;
      let errorCount = 0;
      const allRows = [];
      // Encabezado de la plantilla excel de producto segun idioma
      const headerRow1 =
        language === 'pt'
          ? [
              'Requerimento',
              'Obrigatório',
              'Obrigatório',
              'Obrigatório',
              'Obrigatório',
              'Obrigatório',
              'Obrigatório',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
            ]
          : [
              'Requerimiento',
              'Obligatorio',
              'Obligatorio',
              'Obligatorio',
              'Obligatorio',
              'Obligatorio',
              'Obligatorio',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
              'Opcional',
            ];
      const headerRow2 =
        language === 'pt'
          ? [
              'Erro',
              'Empresa',
              'Fazenda',
              'Nome silo bolsa',
              'Cultura',
              'Produto',
              'Peso embolsado (kg)',
              'Talhão estoque',
              'Data embolsamento',
              'Variedade',
              'Umidade inicial (%)',
              'Tamanho silobolsa (m)',
              'Diâmetro (pés)',
              'Safra',
              'Talhão origem',
              'Responsável embolsamento',
              'Marca silobolsa',
              '% Impureza',
              '% Avariados',
              'Coeficiente de enchimento (kg/m)',
              'Fonte de umidade',
              'Fonte de pesagem',
              'Local do silo bolsa',
              'Tem danos?',
              'Observações',
            ]
          : [
              'Error',
              'Compañía',
              'Establecimiento',
              'Nombre Silobolsa',
              'Especie',
              'Producto',
              'Peso Embolsado (Kg)',
              'Lote Stock',
              'Fecha Embolsado',
              'Variedad',
              'Humedad (%)',
              'Largo (m)',
              'Diámetro (pies)',
              'Cosecha',
              'Lotes origen',
              'Responsable embolsado',
              'Marca del silobolsa',
              '% Impureza',
              '% Defectuoso',
              'Coeficiente de llenado (kg/m)',
              'Fuente de la humedad',
              'Fuente del peso',
              'Camión carga sobre',
              'Observaciones',
            ];

      allRows.push(headerRow1, headerRow2);

      summary.forEach((item) => {
        if (item.success) {
          successCount++;
        } else {
          errorCount++;
          if (item.error) {
            const translatedData = translateData(item.error.data, language);
            const errorMessage = i18n.t(`app.silobag_action.error_messages.${item.error.code}`);

            const errorRow = [
              errorMessage,
              translatedData.companies,
              translatedData.countryside_name,
              translatedData.name,
              translatedData.silobag_species_type_name,
              translatedData.silobag_product_type_name,
              translatedData.input_weight,
              translatedData.lots_name,
              translatedData.bagging_date,
              translatedData.variety,
              translatedData.initial_humidity,
              translatedData.size,
              translatedData.diameter,
              translatedData.silobag_harvest_name,
              translatedData.origin_lots,
              translatedData.responsible_for_bagging,
              translatedData.silobag_brand,
              translatedData.varietal_purity,
              translatedData.split_grain_percentage,
              translatedData.fillying_coefficient,
              translatedData.humidity_source_description,
              translatedData.weight_source_description,
              translatedData.side_charge_description,
              translatedData.observations,
            ];

            // Arreglo de errores para meterlos al excel

            allRows.push(errorRow);
          }
        }
      });

      // Mensajes de éxito, advertencia y error
      if (errorCount === 0) {
        setToast({
          message: i18n.t('app.silobag_action.upload_success'),
          severity: 'success',
          open: true,
        });
      } else if (successCount > 0) {
        setToast({
          message: i18n.t('app.silobag_action.upload_warning'),
          severity: 'warning',
          open: true,
        });
      } else {
        setToast({ message: i18n.t('app.silobag_action.upload_error'), severity: 'error', open: true });
      }

      if (allRows.length > 2) {
        const worksheet = utils.aoa_to_sheet(allRows);
        const workbook = utils.book_new();
        const sheetName = language === 'pt' ? 'Erros' : 'Errores';
        utils.book_append_sheet(workbook, worksheet, sheetName);
        writeFile(workbook, `${sheetName}.xlsx`);
      }
    }
  };

  useEffect(() => {
    if (
      Array.isArray(massiveSilobagSummary) &&
      massiveSilobagSummary.every((item) => typeof item === 'object')
    ) {
      handleSummary(massiveSilobagSummary);
    }
  }, [massiveSilobagSummary]);

  useEffect(() => {
    if (Array.isArray(summaryClose) && summaryClose.every((item) => typeof item === 'object')) {
      const responseItems: ResponseItemClose[] = summaryClose.map((item) => ({
        id: item.ID,
        status: item.status,
        message: item.message,
      }));
      handleSummaryClose(responseItems);
    }
  }, [summaryClose]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      uploadSilobagExcel(event.target.files[0], createMassiveSilobag);
      event.target.value = '';
    }
  };

  const handleFileChangeClose = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      uploadCloseSilobagExcel(event.target.files[0], createMassiveCloseSilobag);
      event.target.value = '';
    }
  };

  const today = new Date().toString();
  const todayDate = formatDate(today);

  const handleRegisterSilobag = () => {
    if (countrysides && countrysides.length > 0) {
      navigate(PATH.SILOBAG + '/new', {
        state: { isGuest: userOrganizationId !== organizationId },
      });
    } else {
      setOpenInfoModal(true);
    }
  };

  const handleSilobagDataSelectionChange = (silobags: SummarySilobagList | undefined) => {
    setTargetSilobagDataSelection(silobags ?? []);
  };

  const hasSilobagWithStatusOne = siloListFilter?.some((silobag) => silobag.silobag_data_statuses.id === 1);

  const handleModalShare = async (silobags: string[]) => {
    const permissionsPromises = silobags.map((siloId) => sharePermissionListService({ query: siloId }));
    const permissions = await Promise.all(permissionsPromises);
    const permissionsData = permissions.map((permission) => permission.summary);
    setPermissions(permissionsData);
    setModalShare(true);
  };
  //EXPORT SB DATA FUNCIONALITY
  const [caseExport, setCaseExport] = useState<string>('');
  const queryParamSilobagService = { organization_id: organizationId, active: filters.active };
  const queryParamSilobagValidated = {
    organization_id: organizationId,
    active: filters.active,
    silobag_data_status_id: SILOBAG_STATUSES_ID.VALID_SILOBAG_STATUS_ID,
  };

  const querySilobagForExport = { organization_id: organizationId };
  const {
    trigger: getSiloData,
    summary: silosToExport,
    isLoading: isLoadingExport,
  } = useService(listSilobagService);

  useEffectOnUpdate(() => {
    if (silosToExport && caseExport.length > 0 && !isLoadingExport) {
      if (caseExport == 'all') {
        GenerateSilobagExcelData(
          silosToExport?.data,
          `${i18n.t('app.silobags')} ${selectedOrganizationName} ${todayDate}`
        );
        setCaseExport('');
      } else {
        GenerateSilobagExcelData(
          silosToExport?.data,
          `${i18n.t(
            'app.silobags'
          )} ${selectedOrganizationName} ${todayDate} - Filtros - + ${paramsExportFilterString}`
        );
        setCaseExport('');
      }
    }
  }, [silosToExport, caseExport, isLoadingExport]);

  const selectedSilobagsIds = targetSilobagDataSelection.length
    ? targetSilobagDataSelection.map((silobag: SummarySilobagList[0]) => silobag.id)
    : [];

  /// --- [LAB-TEMPLATE] Upload template logic --- \\\
  const {
    trigger: importLabProtocol,
    isLoading: isTemplateImportLoading,
    isSuccess: isTemplateImportSuccess,
    isError: isTemplateImportError,
    error: templateImportError,
  } = useService(importLabProtocolService);

  const uploadLabTemplateRef = useRef<HTMLInputElement>(null);
  const handleOpenFileExplorer = () => uploadLabTemplateRef.current?.click();

  const [isInvalidFileType, setIsInvalidFileType] = useState(false);
  const [targetUploadedTemplateName, setTargetUploadedTemplateName] = useState('');
  const handleSubmitLabTemplate = (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    const hasFiles = files && files.length > 0;
    if (!hasFiles) return;

    const [file] = Array.from(files);

    const acceptedFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (!acceptedFileTypes.includes(file.type)) {
      setIsInvalidFileType(true);
      return;
    }

    setTargetUploadedTemplateName(file.name.replace(/\.[^/.]+$/, ''));
    importLabProtocol({ body: { inputFile: file } });
  };

  /// --- [LAB-TEMPLATE] Download template (with upload validations errors) logic --- \\\
  const downloadLabTemplateErrorRef = useRef<HTMLAnchorElement>(null);
  useEffectOnUpdate(() => {
    const { current } = downloadLabTemplateErrorRef;
    // TODO: templateImportError es de tipo UNKNOWN, falta tipar esta propiedad
    const isExcelError =
      isTemplateImportError && (templateImportError as { data: { message: string } })?.data?.message == null;

    if (!isExcelError || !current) return;

    const { URL } = window;
    // TODO: templateImportError es de tipo UNKNOWN, falta tipar esta propiedad
    current.setAttribute('href', URL.createObjectURL((templateImportError as { data: Blob }).data));
    current.setAttribute('download', targetUploadedTemplateName + ' - ERROR.xlsx');
    current.click();
  }, [isTemplateImportError]);

  /// --- [LAB-TEMPLATE] Modal for downloading templates --- \\\
  const [downloadLabTemplateModal, setDownloadLabTemplateModal] = useToggle(false);

  const hasInactiveSilobags = siloListFilter?.some((silobag) => !silobag.active);

  const ERROR_MSG: Record<number, string> = {
    10019: `${i18n.t('app.lab.error.err10019')} (E.#10019)`,
    10020: `${i18n.t('app.lab.error.err10020')} (E.#10020)`,
  };

  // TODO: templateImportError es de tipo UNKNOWN, falta tipar esta propiedad
  const errorCode = (templateImportError as { data: { message: { code: number } } })?.data?.message?.code;
  // TODO: templateImportError es de tipo UNKNOWN, falta tipar esta propiedad
  const errorMessage = (templateImportError as { data: { message: { message: string } } })?.data?.message
    ?.message;
  const displayErrorMessage = ERROR_MSG[errorCode] ?? errorMessage ?? i18n.t('app.lab.error.default');

  const insuranceValidation =
    targetSilobagDataSelection.length === 0 ||
    // country_id !== 1 ||
    !orgWritePermission ||
    isNonValidatedSBList;

  const [silobagsWithErrors, setSilobagsWithErrors] = useState<{ id: string; code: number }[]>([]);
  const handleInsuranceValidation = async () => {
    const availableBrSpeciesIDs = [
      SpeciesID.RICE,
      SpeciesID.CORN,
      SpeciesID.BEAN,
      SpeciesID.SOYBEAN,
      SpeciesID.WHEAT,
    ];
    const availableArgSpeciesIDs = [
      SpeciesID.SOYBEAN,
      SpeciesID.CORN,
      SpeciesID.WHEAT,
      SpeciesID.BARLEY,
      SpeciesID.SUNFLOWER,
    ];
    const localSbWithErrors = targetSilobagDataSelection
      .filter(({ silobag_species_types: { id } }) =>
        country_id === 1 ? !availableArgSpeciesIDs.includes(id) : !availableBrSpeciesIDs.includes(id)
      )
      .map((silobag) => ({ id: silobag.id, code: 20037 }));
    setSilobagsWithErrors(localSbWithErrors);

    if (localSbWithErrors.length === 0) {
      navigate(
        `${PATH.SILOBAG}/insurance/${targetSilobagDataSelection.map((silobag) => silobag.id).join(',')}`
      );
    } else {
      setModalInsurance(true);
    }
  };

  const textInsuranceDisabled = insuranceValidation ? i18n.t('app.silobag_insurance.validation') : '';

  const selectedSilobagsWithFullPermission: SummarySilobagList = targetSilobagDataSelection.filter(
    (silobag) => silobag.full_permission === true
  );

  const selectedSilobagsInactive = targetSilobagDataSelection.filter((silobag) => silobag.active === false);

  const hasWarrantResults = warrantsReferences && warrantsReferences.response.results.length > 0;

  const {
    trigger: postReportSatView,
    isLoading: loadingReportSat,
    isSuccess: successReportSat,
    isError: errorReportSat,
  } = useService(reportSatViewService);

  const buildFormUrl = () => {
    const baseUrl =
      'https://docs.google.com/forms/d/e/1FAIpQLSdM_GYz_r-bAq9iPAzkXrWH6zoDntLiFI69IYy1h5JmUeCP4Q/viewform';

    // ID del campo "Silo IDs suplentes"
    // const siloFieldId = "1898820085";
    // ID del campo "Silo IDs en garantía"
    const siloFieldId = 344740074;
    // Obtener los IDs de las silobolsas seleccionadas separados por ";"
    const siloIds = selectedSilobagsWithFullPermission.map((silo) => silo.id).join(';');
    // Construir parámetros de la URL
    const params = new URLSearchParams({
      usp: 'pp_url',
      [`entry.${siloFieldId}`]: siloIds,
    });

    return `${baseUrl}?${params.toString()}`;
  };

  return (
    <Box
      style={{
        width: '100%',
        margin: 'auto',
      }}
    >
      <a ref={downloadLabTemplateErrorRef} download={'asd'} style={{ display: 'none' }} />
      <input
        ref={uploadLabTemplateRef}
        type="file"
        hidden
        accept=".xlsx"
        onChange={handleSubmitLabTemplate}
      />
      {isInvalidFileType ? (
        <ToastAction
          key="invalid-file-type"
          message={i18n.t('app.lab.error.invalid_file_type')}
          severity="error"
          onClose={() => setIsInvalidFileType(false)}
        />
      ) : null}
      {isTemplateImportSuccess ? (
        <ToastAction
          key="upload-template-success"
          message={i18n.t('app.lab.success.upload')}
          severity="success"
        />
      ) : null}
      {isTemplateImportError ? (
        <ToastAction key="upload-template-error" message={displayErrorMessage} severity={'error'} />
      ) : null}
      {newSiloSuccess.current && (
        <ToastAction key={'success'} message={i18n.t('app.silobag_list.new_silobag')} severity={'success'} />
      )}
      <ModalInfoRegisterSilobags open={openInfoModal} setIsOpen={setOpenInfoModal} />
      {toast.message && (
        <ToastAction
          key={toast.message}
          message={toast.message}
          severity={toast.severity as 'success' | 'error' | 'info' | 'warning'}
          onActionClick={() => setToast({ ...toast, open: false })}
        />
      )}
      {silobagShared.state ? (
        <ToastAction
          message={silobagShared.message}
          severity={silobagShared.type}
          openToast={toastState}
          setOpenToast={setToastState}
        />
      ) : null}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} severity={typeSnackbar} variant="filled" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {showMigrationBanner && (
        <Alert
          severity="warning"
          variant="outlined"
          icon={false}
          sx={{
            width: '100%',
            mb: 2,
            borderRadius: '12px',
            backgroundColor: '#FFF8E1',
            border: '1px solid #F2C94C',
            borderLeft: '5px solid #F2C94C',
            color: '#5F4B00',
            alignItems: 'center',
            boxShadow: '0 2px 6px rgba(242, 201, 76, 0.15)',

            '& .MuiAlert-message': {
              width: '100%',
            },

            '& .MuiAlert-action': {
              alignItems: 'center',
              padding: 0,
              marginRight: 0,
            },
          }}
          action={
            <Button
              size="small"
              onClick={handleCloseMigrationBanner}
              aria-label="Cerrar aviso"
              sx={{
                minWidth: '32px',
                width: '32px',
                height: '32px',
                padding: 0,
                color: '#8A6D00',
              }}
            >
              <CloseIcon fontSize="small" />
            </Button>
          }
        >
          <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
            {i18n.t('app.silobag_list.banner_title')}
          </Typography>

          <Typography variant="body2">{i18n.t('app.silobag_list.banner_description')}</Typography>
        </Alert>
      )}

      <Grid
        container
        sx={mainContainerStyle}
        style={{
          width: '100%',
          margin: 'auto',
          paddingTop: '20px',
        }}
      ></Grid>
      <Grid container sx={mainContainerStyle} style={{ width: '100%', margin: 'auto', paddingTop: '20px' }}>
        <Stack direction={{ xs: 'column', md: 'row' }} style={{ width: '100%' }}>
          <Stack style={{ flex: 1 }}>
            <Paper sx={CustomPaper}>
              <Typography sx={Title} variant="h5">
                {filters.silobag_data_status_id === SILOBAG_STATUSES_ID.NON_VALID_SILOBAG_STATUS_ID
                  ? i18n.t('app.silobag_list.your_silobags')
                  : i18n.t('app.silobag_list.your_siloreales')}
              </Typography>
            </Paper>
          </Stack>
          <Stack direction="row" flexWrap="wrap" justifyContent={{ xs: 'center' }}>
            <Box component="span" columnGap={10}>
              <Button
                startIcon={<img src={downloadPdfIcon} alt="download" />}
                id="fade-button"
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant="outlined"
                sx={{
                  ...configButtonStylesOutlined,
                  fontSize: { xs: 12.7, sm: 12.7 },
                }}
                size="medium"
                disabled={isLoadingCMA}
              >
                {isLoadingCMA ? (
                  <CircularProgress sx={{ color: 'green' }} size={20} />
                ) : (
                  i18n.t('app.silobag_list.export_data')
                )}
              </Button>
              <Menu
                id="fade-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                  list: {
                    'aria-labelledby': 'fade-button',
                  },
                }}
                slots={{
                  transition: Fade,
                }}
              >
                <MenuItem
                  onClick={() => {
                    setCaseExport('all');
                    getSiloData({ query: querySilobagForExport });
                  }}
                  sx={{ color: '#26C4B7' }}
                >
                  {i18n.t('app.silobag_list.export_all')}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setCaseExport('all');
                    getSiloData({ query: queryParamSilobagValidated });
                  }}
                  sx={{ color: '#26C4B7' }}
                >
                  {i18n.t('app.silobag_list.export_stock_validate')}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    const { paginationModel, ...restFilters } = filters;
                    paginationModel;
                    setCaseExport('filtered');
                    getSiloData({
                      query: {
                        ...queryParamSilobagService,
                        ...restFilters,
                      },
                    });
                  }}
                  sx={{ color: '#26C4B7' }}
                  disabled={filteredUrl.length === 0}
                >
                  {i18n.t('app.silobag_list.export_view')}
                </MenuItem>
                <Tooltip
                  title={i18n.t('app.tooltip_sb_selected')}
                  disableHoverListener={targetSilobagDataSelection.length > 0}
                >
                  <Box>
                    <MenuItem
                      onClick={() =>
                        GenerateSilobagExcelData(
                          targetSilobagDataSelection,
                          `${i18n.t('app.silobags')} ${selectedOrganizationName} ${todayDate} - ${i18n.t(
                            'app.silobag_list.selected'
                          )}`
                        )
                      }
                      sx={{ color: '#26C4B7' }}
                      disabled={targetSilobagDataSelection.length === 0}
                    >
                      {i18n.t('app.silobag_list.export_selects')}
                    </MenuItem>
                  </Box>
                </Tooltip>
                <MenuItem onClick={getExtracions} sx={{ color: '#26C4B7' }}>
                  {i18n.t('app.silobag_list.export_extraction')}
                </MenuItem>
              </Menu>
            </Box>
            <Box>
              <Button
                id="fade-button-massive-upload"
                aria-controls={openMassive ? 'fade-menu-massive-upload' : undefined}
                aria-haspopup="true"
                aria-expanded={openMassive ? 'true' : undefined}
                onClick={handleClickMassive('upload')}
                variant="contained"
                disabled={!orgWritePermission || isTemplateImportLoading}
                sx={configButtonStylesContained}
                style={{ minWidth: '180px' }}
                size="medium"
              >
                {isTemplateImportLoading ? (
                  <CircularProgress sx={{ color: 'green' }} size={20} />
                ) : (
                  i18n.t('app.silobag_list.massive_actions')
                )}
              </Button>
              <Menu
                id="fade-menu-massive-upload"
                anchorEl={anchorElMassive}
                open={openMassive.upload}
                onClose={() => setOpenMassive((prev) => ({ ...prev, upload: false }))}
                slotProps={{
                  paper: {
                    sx: {
                      pr: 6,
                    },
                  },

                  list: {
                    'aria-labelledby': 'fade-button-massive-upload',
                  },
                }}
                slots={{
                  transition: Fade,
                }}
              >
                <MenuItem disabled sx={{ fontWeight: 'bold', color: 'black', fontSize: '0.875rem' }}>
                  {i18n.t('app.silobag_list.quality_samples')}
                </MenuItem>
                <MenuItem onClick={handleOpenFileExplorer} sx={{ color: '#26C4B7' }}>
                  {i18n.t('app.silobag_list.charge_page.quality')}
                </MenuItem>
                <Tooltip
                  title={
                    !targetSilobagDataSelection.length ? i18n.t('app.lab.template_download.tooltip.init') : ''
                  }
                >
                  <Box>
                    <MenuItem
                      disabled={!targetSilobagDataSelection.length}
                      onClick={() => setDownloadLabTemplateModal(true)}
                      sx={{ color: '#26C4B7' }}
                    >
                      {i18n.t('app.silobag_list.download_page.quality')}
                    </MenuItem>
                    <MenuItem onClick={() => setDownloadLabTemplateModal(true)} sx={{ color: '#26C4B7' }}>
                      {i18n.t('app.silobag_list.download_page.quality_all')}
                    </MenuItem>
                  </Box>
                </Tooltip>
                <MenuItem disabled sx={{ fontWeight: 'bold', color: 'black', fontSize: '0.875rem' }}>
                  {i18n.t('app.silobag_list.masive_register')}
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    setAnchorElMassive(null);
                    setOpenMassive((prev) => ({ ...prev, upload: false }));
                    setOpenMassiveSilobagRegisterModal(true);
                  }}
                  sx={{ color: '#26C4B7' }}
                >
                  <Box>{i18n.t('app.silobag_list.charge_page.register')}</Box>
                  <Box style={{ position: 'relative' }}>
                    <Box sx={{ position: 'absolute', top: -16, left: 8 }}>
                      <BetaBadge />
                    </Box>
                  </Box>
                </MenuItem>

                <MenuItem onClick={handleDownloadClick} sx={{ color: '#26C4B7' }}>
                  {i18n.t('app.silobag_list.download_page.register')}
                </MenuItem>
                <MenuItem disabled sx={{ fontWeight: 'bold', color: 'black', fontSize: '0.875rem' }}>
                  {i18n.t('app.certification_sat.report_sat_certification')}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    postReportSatView({ query: { organization_id: organizationId } });
                    setOpenReportModal(true);
                  }}
                  disabled={loadingReportSat}
                  sx={{ color: '#26C4B7', pl: 2 }}
                >
                  {i18n.t('app.certification_sat.generate_report')}{' '}
                  {loadingReportSat ? <CircularProgress sx={{ marginLeft: 2 }} size={16} /> : null}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    postReportSatView({
                      query: { silobags: selectedSilobagsIds },
                    });
                    setOpenReportModal(true);
                  }}
                  sx={{ color: '#26C4B7', pl: 2 }}
                  disabled={selectedSilobagsIds.length === 0 || loadingReportSat}
                >
                  {i18n.t('app.certification_sat.generate_filter_report')}
                  {loadingReportSat && selectedSilobagsIds.length > 0 ? (
                    <CircularProgress sx={{ marginLeft: 2 }} size={16} />
                  ) : null}
                </MenuItem>
                <MenuItem disabled sx={{ fontWeight: 'bold', color: 'black', fontSize: '0.875rem' }}>
                  {i18n.t('app.silobag_list.massive_close')}
                </MenuItem>
                <MenuItem onClick={handleUploadCloseClick} sx={{ color: '#26C4B7' }}>
                  {i18n.t('app.silobag_list.charge_page.close')}
                </MenuItem>
                <MenuItem onClick={handleDownloadCloseClick} sx={{ color: '#26C4B7' }}>
                  {i18n.t('app.silobag_list.download_page.close')}
                </MenuItem>
                <MenuItem disabled sx={{ fontWeight: 'bold', color: 'black', fontSize: '0.875rem' }}>
                  {i18n.t('app.archived_silobags.archive_button')}
                </MenuItem>
                <MenuItem
                  disabled={
                    filters.silobag_data_status_id === 2 ||
                    targetSilobagDataSelection.length === 0 ||
                    !filters.active
                  }
                  sx={{ color: '#26C4B7' }}
                  onClick={() => setOpenArchiveModal(true)}
                >
                  {i18n.t('app.archived_silobags.archive')}
                </MenuItem>
              </Menu>
              <input
                type="file"
                id="fileUpload"
                style={{ display: 'none' }}
                accept=".xls,.xlsx"
                onChange={handleFileChange}
              />
              <input
                type="file"
                id="fileUploadClose"
                style={{ display: 'none' }}
                accept=".xls,.xlsx"
                onChange={handleFileChangeClose}
              />
              {targetSilobagDataSelection.length === 0 && !hasInactiveSilobags ? (
                <>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={configButtonStylesContained}
                    disabled={isCountrysideLoading || !orgWritePermission}
                    onClick={handleRegisterSilobag}
                  >
                    {i18n.t('app.silobag_list.register_silobag')}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="contained"
                    sx={{ ...configButtonStylesContained, background: '#FF0000', color: '#FFFFFF' }}
                    onClick={() => {
                      setModalClose(true);
                      setIsMassiveClose(false);
                    }}
                    disabled={
                      hasInactiveSilobags ||
                      (!orgWritePermission && selectedSilobagsWithFullPermission.length === 0)
                    }
                  >
                    {i18n.t('app.silobag_list.close_silobags')}
                  </Button>
                </>
              )}
              {targetSilobagDataSelection.length < 3 && !hasInactiveSilobags ? (
                <Button
                  variant="outlined"
                  size="medium"
                  sx={{
                    ...configButtonStylesOutlined,
                    fontSize: { xs: 12.7, sm: 12.7 },
                  }}
                  onClick={() => setModalExtraction(true)}
                  disabled={!orgWritePermission}
                >
                  {i18n.t('app.silobag_list.make_extraction')}
                </Button>
              ) : null}
              <span>
                <Button
                  variant="contained"
                  sx={{
                    ...configButtonStylesContained,
                    width: { xs: '95%', md: '180px' },
                    backgroundColor: '#961EFA',
                    color: '#FFF',
                  }}
                  onClick={() => setOpenWarrantModal(true)}
                  disabled={
                    !orgWritePermission ||
                    selectedSilobagsWithFullPermission.length === 0 ||
                    country_id !== 1 ||
                    selectedSilobagsInactive.length > 0
                  }
                >
                  {i18n.t('app.quote_silo_warrant')}
                </Button>
              </span>

              <span>
                <Button
                  component="a"
                  href={buildFormUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  sx={{
                    ...configButtonStylesContained,
                    width: { xs: '95%', md: '180px' },
                    backgroundColor: '#961EFA',
                    color: '#FFF',
                  }}
                  disabled={
                    !orgWritePermission ||
                    selectedSilobagsWithFullPermission.length === 0 ||
                    country_id !== 1 ||
                    selectedSilobagsInactive.length > 0
                  }
                >
                  {i18n.t('app.quote_silo_iwarrant')}
                </Button>
              </span>
              {/* <span>
                <Button
                  component="a"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdM_GYz_r-bAq9iPAzkXrWH6zoDntLiFI69IYy1h5JmUeCP4Q/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="contained"
                  sx={{
                    ...configButtonStylesContained,
                    width: { xs: '95%', md: '180px' },
                    backgroundColor: '#961EFA',
                    color: '#FFF',
                  }}
                  disabled={
                    !orgWritePermission ||
                    selectedSilobagsWithFullPermission.length === 0 ||
                    country_id !== 1 ||
                    selectedSilobagsInactive.length > 0
                  }
                >
                  {i18n.t('app.quote_silo_iwarrant')}
                </Button>
              </span> */}
              <Tooltip title={textInsuranceDisabled} sx={{ display: insuranceValidation ? 'block' : 'none' }}>
                <span>
                  <Button
                    variant="contained"
                    sx={{
                      ...configButtonStylesContained,
                      width: { xs: '95%', md: '180px' },
                      backgroundColor: '#961EFA',
                      color: '#FFF',
                    }}
                    disabled={insuranceValidation || selectedSilobagsInactive.length > 0}
                    onClick={handleInsuranceValidation}
                  >
                    {i18n.t('app.quote_silo_insurance')}
                  </Button>
                </span>
              </Tooltip>
              <Tooltip
                title={i18n.t('app.tooltip_sb_share_selected')}
                disableHoverListener={targetSilobagDataSelection.length > 0}
              >
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      ...configButtonStylesContained,
                      background: 'rgba(107, 170, 0, 0.25)',
                      color: targetSilobagDataSelection.length === 0 ? 'inherit' : '#6baa00',
                    }}
                    onClick={() => {
                      handleModalShare(selectedSilobagsIds);
                      setModalShare(true);
                    }}
                    disabled={
                      targetSilobagDataSelection.length === 0 ||
                      (!orgFullPermission && selectedSilobagsWithFullPermission.length === 0)
                    }
                  >
                    <span>{i18n.t('app.silobag_share.share_silobag_title')}</span>
                    <span style={{ marginLeft: '10px', marginTop: '5px' }}>
                      <img
                        src={
                          targetSilobagDataSelection.length === 0 ||
                          (!orgFullPermission && selectedSilobagsWithFullPermission.length === 0)
                            ? shareDisabledIcon
                            : ShareICON
                        }
                        style={{ objectFit: 'contain' }}
                      />
                    </span>
                  </Button>
                </span>
              </Tooltip>
            </Box>
          </Stack>
        </Stack>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          style={{
            textAlign: 'left',
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '20px',
            marginTop: '15px',
          }}
          width={'100%'}
          display={'flex'}
          position="relative"
          alignItems={{ xs: 'start', md: 'center' }}
        >
          <Stack direction={'row'} display={'flex'} alignItems={'center'}>
            <Typography
              component="span"
              style={{ borderRight: '1px solid #B1B3B4', padding: '8px 12px' }}
              sx={typographyStyle}
            >
              <span style={{ fontSize: '1.5rem' }}>{siloHeaderData.silobagQty} </span>
              {filters.silobag_data_status_id === SILOBAG_STATUSES_ID.NON_VALID_SILOBAG_STATUS_ID
                ? i18n.t('app.silobag_list.your_silobags')
                : i18n.t('app.silobag_list.your_siloreales')}
            </Typography>

            {!isCloseList ? (
              <Typography component="span" sx={typographyStyle}>
                <span style={{ fontSize: '1.5rem' }}>
                  {i18n.numberToDelimited(formatTons(siloHeaderData?.remainingStock) || 0, {
                    delimiter: i18n.t('config.delimiter'),
                  })}{' '}
                </span>
                Toneladas
              </Typography>
            ) : null}
          </Stack>
          {isCloseList ? null : (
            <>
              <Typography
                component="span"
                style={{ marginRight: '10px', borderRight: '1px solid #B1B3B4', padding: '8px 12px' }}
              >
                <span style={{ fontSize: '1.5rem' }}>{percetageFiltered} %</span>{' '}
                {i18n.t('app.silobag_list.your_stock_total')}
              </Typography>
              {siloHeaderData.web_silobags_stock > 0 && (
                <Tooltip title={i18n.t('app.missing_tons')} placement="top" arrow>
                  <Typography component="span" style={{ marginRight: '10px' }}>
                    <span style={{ fontSize: '1.5rem' }}>
                      {i18n.numberToDelimited(formatTons(siloHeaderData.web_silobags_stock) || 0, {
                        delimiter: i18n.t('config.delimiter'),
                      })}{' '}
                    </span>
                    {i18n.t('app.silobag_list.non_validated_tons')}
                  </Typography>
                </Tooltip>
              )}
            </>
          )}
          {isCloseList ? (
            <>
              <Typography component="span" sx={typographyStyle}>
                <span style={{ fontSize: '1.5rem' }}>
                  {i18n.numberToDelimited(formatTons(siloHeaderData?.filteredInputWeight) || 0, {
                    delimiter: i18n.t('config.delimiter'),
                  })}{' '}
                </span>
                {i18n.t('app.silobag_list.bagged_tons')}
              </Typography>
              <Typography component="span" sx={typographyStyle}>
                <span style={{ fontSize: '1.5rem' }}>
                  {i18n.numberToDelimited(formatTons(siloHeaderData?.filteredExtractedWeight) || 0, {
                    delimiter: i18n.t('config.delimiter'),
                  })}{' '}
                </span>
                {i18n.t('app.silobag_list.extracted_tons')}
              </Typography>
              <Typography component="span">
                <span style={{ fontSize: '1.5rem' }}>
                  {i18n.numberToDelimited(formatTons(siloHeaderData?.filteredRemainingStock) || 0, {
                    delimiter: i18n.t('config.delimiter'),
                  })}{' '}
                </span>

                {i18n.t('app.silobag_list.tonnage_difference')}
              </Typography>
            </>
          ) : null}
          <Box
            height="100%"
            position={{ xs: 'relative', md: 'absolute' }}
            top={{ xs: 'auto' }}
            right={{ xs: 'auto', md: '15px' }}
            left={{ xs: '0', md: 'auto' }}
            display="flex"
            alignItems="center"
            justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
            width={{ xs: '100%', md: 'auto' }}
          >
            {(webSilobagsCount?.incomplete_silobags_count ?? 0) > 0 && (
              <Tooltip title={i18n.t('app.missing_tons')} placement="top-end">
                <Typography color={'#000000'} textAlign={'end'} sx={{ cursor: 'default', marginRight: 2 }}>
                  {i18n.t('app.missing_tons_title')}
                </Typography>
              </Tooltip>
            )}
          </Box>
        </Stack>
        <SilobagListFilters
          updateHeaderData={handlerUpdateHeaderData}
          handleGetSiloListFilter={handleGetSiloListFilter}
          handleGetParamsFilter={handleGetParamsFilter}
          handleGetSiloListAll={handleGetSiloListAll}
          isSuccess={isSuccess}
          isSuccessClose={isSuccessClose}
          isMassiveSuccess={isMassiveClose}
          extractionSuccess={extractionSuccess}
          targetSilobagDataSelection={targetSilobagDataSelection}
          onSilobagDataSelectionChange={handleSilobagDataSelectionChange}
          setSiloListAll={setSiloListAll}
          setIsNonValidatedSBList={setIsNonValidatedSBList}
          setIsCloseList={setIsCloseList}
          isCloseList={isCloseList}
          IsSilobagValidated={hasSilobagValidated}
        />
        {modalClose && (
          <SilobagModalMassiveClose
            open={modalClose}
            setOpen={setModalClose}
            silobagData={targetSilobagDataSelection}
            setIsMassiveClose={setIsMassiveClose}
          />
        )}
        {modalShare && (
          <SilobagShareModal
            open={modalShare}
            setOpen={setModalShare}
            siloId={selectedSilobagsIds}
            data={dataSiloPermission}
            massiveData={permissions}
            isLoadingData={isLoadingSiloPermission}
            getData={getSiloPermission}
            setSilobagShared={setSilobagShared}
            hasInvalidStatus={hasSilobagWithStatusOne}
            silobagsData={targetSilobagDataSelection.map((silobag) => ({
              id: silobag.id,
              name: silobag.name,
              full_permission: silobag.full_permission,
            }))}
          />
        )}
        {openReportModal && successReportSat && (
          <ReportSatelitalModal
            open={openReportModal}
            setOpen={setOpenReportModal}
            isLoadingPost={loadingReportSat}
            isSuccessPost={successReportSat}
          />
        )}
        <SilobagModalMassiveClose
          open={modalClose}
          setOpen={setModalClose}
          silobagData={targetSilobagDataSelection}
          setIsMassiveClose={setIsMassiveClose}
        />
      </Grid>
      {modalExtraction && (
        <ExtractionAction
          type="new"
          selectedSilobags={targetSilobagDataSelection}
          fromSilobag={true}
          open={modalExtraction}
          setOpen={setModalExtraction}
          silobagsList={siloListAll}
          remainingStock={remainingStock} // TODO: Verificar si hay que consumir endpoint o si se puede sacar de otro lado
          setRemainingStock={setRemainingStock}
          setSnackbarMessage={setSnackbarMessage}
          setTypeSnackbar={setTypeSnackbar}
          setOpenSnackbar={setOpenSnackbar}
          setExtractionSuccess={setExtractionSuccess}
        />
      )}
      {modalInsurance && (
        <SilobagInsuranceValidation
          modalInsurance={modalInsurance}
          closeModal={() => setModalInsurance(false)}
          silobagErrorList={silobagsWithErrors}
          silobagList={targetSilobagDataSelection}
          isLoading={false}
        />
      )}
      {downloadLabTemplateModal ? (
        <DownloadLabTemplateModal
          selectedSilobags={targetSilobagDataSelection}
          open={downloadLabTemplateModal}
          onClose={() => {
            setDownloadLabTemplateModal(false);
            setAnchorElMassive(null);
            setOpenMassive({ upload: false, close: false });
          }}
        />
      ) : null}
      {openWarrantModal && hasWarrantResults ? (
        <WarrantApplicationModal
          open={openWarrantModal}
          setOpen={setOpenWarrantModal}
          companyId={warrantsReferences.response.results[0].companyId}
          data={targetSilobagDataSelection.map((silobag) => ({
            id: silobag.id,
            name: silobag.name,
            fullPermissions: silobag.full_permission,
          }))}
        />
      ) : (
        openWarrantModal &&
        !hasWarrantResults && (
          <WarrantIntroductionModal open={openWarrantModal} setOpen={setOpenWarrantModal} />
        )
      )}
      {openMassiveSilobagRegisterModal ? (
        <SilobagMassiveRegisterSpreadsheetModal
          open={openMassiveSilobagRegisterModal}
          onClose={() => setOpenMassiveSilobagRegisterModal(false)}
        />
      ) : null}
      {openArchiveModal && (
        <ArchivableSbModal
          open={openArchiveModal}
          setOpen={setOpenArchiveModal}
          silobags={targetSilobagDataSelection}
          setToastArchivable={setToastArchivable}
        />
      )}
      {toastArchivable.open && (
        <ToastAction
          key={toastArchivable.message}
          message={toastArchivable.message}
          severity={toastArchivable.severity}
        />
      )}
      {errorReportSat && <ToastAction message={i18n.t('app.certification_sat.error')} severity="error" />}
    </Box>
  );
}
